import { CORE_MANAGER_URLS, OLD_MANAGER_URLS } from "@/consts";

type NullableBoolean = boolean | null;

type IframeTypes = "core" | "old";

const DATA: Record<IframeTypes, NullableBoolean> = {
  core: null,
  old: null,
};

const setIframeType = (origin: string) => {
  DATA.core = CORE_MANAGER_URLS.includes(origin);
  DATA.old = OLD_MANAGER_URLS.includes(origin);
  console.log("iframe types", origin, JSON.stringify(DATA));
};

const getIframeType = (type: IframeTypes) => {
  const value = DATA[type];
  if (value === null) {
    throw new Error(`The iframe type is not set yet: ${type}`);
  }

  return value;
};

export default {
  setIframeType,
  getIframeType,
};
